<template>

  <el-main
    class="main_content"
    style="padding: 0"
  >
    <div class="cont_navs_header">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>
          <a @click="goBack">商品规格管理</a>
        </el-breadcrumb-item>
        <el-breadcrumb-item>
          <a>新增sku</a>
        </el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <div class="contain_div">
      <ul
        v-if="goodName != null"
        class="cont_btns2"
      >
        <li>
          <el-button
            @click="goBack"
            type="primary"
          >返回规格列表</el-button>
        </li>
      </ul>
      <div class="contain_header1 clr1">

      </div>

      <div
        class="contain_body"
        style="padding:20px"
        v-loading='divLoading'
      >

        <el-form
          style="width:850px;"
          ref="form"
          :model="form"
          label-width="80px"
          :rules="addFormRule"
        >
          <el-form-item
            label="商品"
            prop='goodName'
          >
            <el-input
              v-model="form.goodName"
              disabled
              placeholder="100"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="库存数量"
            prop='goodNum'
          >
            <el-input
              v-model="form.goodNum"
              type="number"
              placeholder="100"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="触底数量"
            prop='lowNum'
          >
            <el-input
              v-model="form.lowNum"
              type="number"
              placeholder="100"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="团购价"
            prop='goodPrice'
          >
            <el-input
              v-model="form.goodPrice"
              placeholder="12.2"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="代理价"
            prop='proxyPrice'
          >
            <el-input
              v-model="form.proxyPrice"
              placeholder="12.2"
            ></el-input>
          </el-form-item>

          <el-form-item
            required
            v-for="(item, index) in form.guides"
            :key="index"
            :label="item.property"
            :prop="'guides.' + index + '.value'"
            :rules="{
              required: true, message: '规格必须', trigger: 'blur'
            }"
          >
            <el-select
              v-model="form.guides[index].value"
              placeholder="全部"
              @change="$set(form.guides[index], form.guides[index].value, $event)"
            >
              <el-option
                v-for="guide in item.detail"
                :key="guide.property_value"
                :label="guide.property_value"
                :value="guide.property_value"
              ></el-option>
            </el-select>
          </el-form-item>

          <el-form-item
            label="上架状态"
            prop="status"
          >
            <el-select
              v-model="form.status"
              placeholder="全部"
            >
              <el-option
                label="待上架"
                value='1'
              ></el-option>
              <el-option
                label="上架"
                value="2"
              ></el-option>
            </el-select>
          </el-form-item>

          <el-form-item>
            <el-button
              type="primary"
              @click="onSubmit('form')"
              :loading="addLoading"
            >{{wordName}}</el-button>
            <el-button @click="resetForm('form')">重置</el-button>
          </el-form-item>
        </el-form>

        <!-- <el-form
          label-position="top"
          class="m-search"
          size='small'
          :model="form"
          ref="form"
          :rules="addFormRule"
        >
          <el-form-item
            label="商品名称"
            prop='goodName'
          >
            <el-input v-model="form.goodName"></el-input>
          </el-form-item>

          <div class="pri-div">
            <div class="guii-list">
              <div
                v-for="(item,index) in form.guides"
                :key="index"
              >
                <div class="guide-name">颜色</div>
                <el-checkbox-group v-model="checkList">
                  <el-checkbox label="复选框 A"></el-checkbox>
                  <el-checkbox label="复选框 B"></el-checkbox>
                  <el-checkbox label="复选框 C"></el-checkbox>

                </el-checkbox-group>
              </div>
              <div>
                <div class="guide-name">颜色</div>
                <el-checkbox-group v-model="checkList">
                  <el-checkbox label="复选框 A"></el-checkbox>
                  <el-checkbox label="复选框 B"></el-checkbox>
                  <el-checkbox label="复选框 C"></el-checkbox>

                </el-checkbox-group>
              </div>
            </div>

            <div class="guide-list">
              <div class="guide-head">
                <span>颜色</span>
                <span>尺寸</span>
                <span style="width:100px">价格</span>
                <span style="width:100px">库存</span>
                <span>操作</span>
              </div>
              <div>
                <span>红色</span>
                <span>1.2</span>
                <div>
                  <el-input
                    clearable
                    style="width:100px"
                    v-model="filters.keyword"
                    placeholder="请输入"
                  >
                  </el-input>
                </div>
                <div>
                  <el-input
                    clearable
                    style="width:100px"
                    v-model="filters.keyword"
                    placeholder="请输入"
                  >
                  </el-input>
                </div>
                <div>
                  <el-button
                    @click="upHouseStatus(1, 3)"
                    type="text"
                    size="small"
                  >删除</el-button>
                </div>
              </div>

              <div>
                <span>红色</span>
                <span>1.2</span>
                <div>
                  <el-input
                    clearable
                    style="width:100px"
                    v-model="filters.keyword"
                    placeholder="请输入"
                  >
                  </el-input>
                </div>
                <div>
                  <el-input
                    clearable
                    style="width:100px"
                    v-model="filters.keyword"
                    placeholder="请输入"
                  >
                  </el-input>
                </div>
                <div>
                  <el-button
                    @click="upHouseStatus(1, 3)"
                    type="text"
                    size="small"
                  >删除</el-button>
                </div>
              </div>

            </div>

          </div>

          <el-form-item>
            <el-button
              type="primary"
              @click="addPost()"
              :loading="addLoading"
            >新增</el-button>
            <el-button @click="dialogAddVisible = false">重置</el-button>
          </el-form-item>
        </el-form> -->

      </div>

    </div>

  </el-main>

</template>

<script>
import { bus } from "../../bus.js";
import API from "../../api/api_user";
export default {
  name: "addSku",
  created() {
    var that = this;
    this.goodName = this.$route.query.goodName;
    this.total = this.$route.query.total;
    this.goodId = this.$route.query.goodId;
    this.form.goodId = this.goodId;
    this.form.goodName = this.goodName;
    that.divLoading = true;
    var para = {
      token: localStorage.getItem("api_token"),
      goodId: that.goodId
    };
    API.selectGoodGuides(para)
      .then(
        function(result) {
          if (result.key == 1000) {

            //
            if (that.$route.query.judge != null) {
              that.wordName = '修改';
              //渲染选择的数据
              that.form.id = that.$route.query.judge.id;
              that.form.status = that.$route.query.judge.status.toString();
              that.form.proxyPrice = that.$route.query.judge.proxy_price;
              that.form.goodName = that.$route.query.judge.good_name;
              that.form.goodPrice = that.$route.query.judge.good_price;
              that.form.goodNum = that.$route.query.judge.good_num;
              that.form.lowNum = that.$route.query.judge.low_num;
              var pro = JSON.parse(that.$route.query.judge.properties);

              for (var i = 0; i < result.result.list.length; i++) {
                for (var j = 0; j < pro.length; j++) {
                  if (result.result.list[i].property_name_id == pro[j].id) {

                    result.result.list[i].value = pro[j].value;
                    break;
                  }
                }
              }
              that.form.guides = result.result.list;

            } else {
              that.form.guides = result.result.list;
              for (var i = 0; i < that.form.guides.length; i++) {
                that.form.guides[i].value =
                that.form.guides[i].detail[0].property_value;
              }
            }

          } else {
            that.$message.error({
              showClose: true,
              message: result.message || "登录失败",
              duration: 2000
            });
          }
          that.divLoading = false;
        },
        function(err) {
          that.divLoading = false;
          that.$message.error({
            showClose: true,
            message: err.toString(),
            duration: 2000
          });
        }
      )
      .catch(function(error) {
        that.divLoading = false;
        console.error(error)
        that.$message.error({
          showClose: true,
          message: "请求出现异常",
          duration: 2000
        });
      });
  },
  mounted() {
    this.tableHeight = document.documentElement.clientHeight - 330;
  },
  data() {
    return {
      tableHeight:null,
      total:null,
      wordName: "新增",
      divLoading: false,
      checkList: null,
      filters: {
        num_status: null,
        status: null,
        keyword: null,
        pid: null
      },
      goodName: null,
      goodId: null,
      form: {
        lowNum:0,
        goodId:null,
        status:null,
        properties:null,
        goodPrice:null,
        goodNum:null,
        proxyPrice:null,
        aOnePrice:null,
        aTwoPrice:null,
        aThreePrice:null,
        bOnePrice:null,
        bTwoPrice:null,
        bThreePrice:null,
        guides:[],
        id:null
      },
      addFormRule: {
        goodPrice: [
          { required: true, message: "请输入团购价", trigger: "blur" }
        ],
        proxyPrice: [
          { required: true, message: "请输入代理价", trigger: "blur" }
        ],
        goodNum: [
          { required: true, message: "请输入规格名称", trigger: "blur" }
        ],
        lowNum: [
          { required: true, message: "请输入触底数量", trigger: "blur" }
        ],
        status: [{ required: true, message: "请选择上架状态", trigger: "blur" }]
      },
      addLoading: false,
      loading: false
    };
  },
  watch: {
    form: {
      handler(val, oldVal) {
        var that = this;
      },
      deep: true
    }
  },
  methods: {
    onSubmit() {
      let that = this;
      that.$refs["form"].validate(valid => {
        if (valid) {
          let para = {
            token:localStorage.getItem("api_token")
          };
          //组装sku_list
          var sku_list = [{
            goodId:that.form.goodId,
            id:that.form.id,
            lowNum:that.form.lowNum,
            status:that.form.status,
            goodPrice:that.form.goodPrice,
            goodNum:that.form.goodNum,
            proxyPrice:that.form.proxyPrice
          }];
          var pros = [];
          for (var i=0; i<that.form.guides.length; i++)
          {
            pros.push({
              id:that.form.guides[i].property_name_id,
              name:that.form.guides[i].property,
              value:that.form.guides[i].value
            });
          }
          sku_list[0].properties = JSON.stringify(pros);
          para.sku_list = JSON.stringify(sku_list);
          that.addLoading = true;
          API.up_add_good_sku(para)
            .then(
              function(result) {
                that.addLoading = false;
                if (result.key == 1000) {
                  if (that.form.id) {
                    that.$message.success({
                      showClose: true,
                      message: "修改成功",
                      duration: 1500
                    });
                  } else {
                    that.$message.success({
                      showClose: true,
                      message: "创建成功",
                      duration: 1500
                    });
                  }

                  // resetForm();
                } else {
                  that.$message.error({
                    showClose: true,
                    message: result.message || "登录失败",
                    duration: 2000
                  });
                }
              },
              function(err) {
                that.loading = false;
                console.error(err);
                that.$message.error({
                  showClose: true,
                  message: err.toString(),
                  duration: 2000
                });
              }
            )
            .catch(function(error) {
              that.loading = false;
              console.error(error);
              that.$message.error({
                showClose: true,
                message: "请求出现异常",
                duration: 2000
              });
            });
        } else {
          that.$message.error({
            showClose: true,
            message: "请检查是否有信息未填写",
            duration: 2000
          });
        }
      });
    },
    inide() {
      console.info(this.form.guides);
    },
    goBack() {
      if (this.total == 2) {
        this.$router.push({
        path: "/skuList",
        query: {
          goodId: this.goodId,
          goodName: this.goodName
        }
      });
      } else {
        this.$router.push({
        path: "/skuList",
        query: {
        }
      });
      }
    }
  }
};
</script>

<style>
.table_head {
  background-color: #f8f8f8 !important;
  border-right: 1px solid #eee;
  border-bottom: 1px solid #eee;
  border-top: 1px solid #eee;
}

.main_content {
  position: absolute;
  left: 210px;
  top: 105px;
  right: 0;
  bottom: 0;
  background-color: #f2f2f2;
  padding: 0;
}

.cont_navs {
  background-color: #fff;
  width: 100%;
  height: 55px;
  box-sizing: border-box;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1);
  text-align: center;
  margin-bottom: 20px;
}
.cont_navs li {
  display: inline-block;
  line-height: 21px;
  padding: 17px 0;
  margin: 0 20px;
  height: 55px;
  color: #bbb;
  font-size: 15px;
  text-align: center;
  cursor: pointer;
}
.cont_navs li:hover {
  color: #409eff;
}

.ac_li {
  color: #409eff;
  border-bottom: solid 2px #409eff;
}
.contain_div {
  margin: 10px;
}
.cont_btns2 {
  margin: 0px 0px 20px 0;
}
.contain_header {
  background-color: #fff;
  padding: 10px;
}
.cont_btns1 li {
  display: inline-block;
}

.contain_body {
  background-color: #fff;
  margin-top: 20px;
  position: relative;
  padding-bottom: 35px;
}
.contain_body_head {
  display: block;
  padding: 10px 0 10px 10px;
  font-size: 16px;
  background-color: #f8f8f8;
}
.pageDiv {
  position: absolute;
  right: 0;
  bottom: 0;
}

.m-search {
  margin-bottom: -15px;
}
.el-button + .el-button {
  margin-left: 0px !important;
}

.pri-div {
  display: flex;
  width: 100%;
  justify-content: space-between;
}

.pri-div > div {
  width: 48%;
  border: 1px solid #dadada;
  border-radius: 10px;
  margin-bottom: 20px;
}
.guii-list {
  padding: 0 10px 10px 10px;
}
.guide-name {
  margin-top: 10px;
  margin-bottom: 10px;
}
.item-value span {
  background-color: #bbb;
  display: inline-block;
  width: 100px;
  padding: 5px 10px;
  cursor: pointer;
  margin-right: 10px;
  margin-top: 10px;
  text-align: center;
}

.guide-list > div {
  display: flex;
  justify-content: space-around;
  align-items: center;
}
.guide-list .el-input__inner {
  height: 27px;
  padding-right: 0px;
}
.guide-head {
  padding-top: 10px;
  background-color: #fafafa;
  border-top-right-radius: 10px;
  border-top-left-radius: 10px;
  margin-bottom: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/good/addSku.vue